<div class="userprofile-container ya-typography" (swiperight)="SwiperNavigateBack()">
  <ya-subheader class="ya-header-title-wrapper" [hasContent]="true" [disableNavigateBack]="true"
    (onNavigateBackClick)="navigateBack()">
    <h1 class="ya-header-title"><span langkey="phUserProfile_MyProfile"></span></h1>
  </ya-subheader>
  <div class="ya-page-content ya-page-content--webshop ya-page-content--inset ya-page-content--aligncenter">
    <div class="userprofile-content">
      <div class="userprofile-info-detail">
        <div class="userprofile-info-wrapper">
          <div class="userprofile-info-item">
            <h3 class="userprofile-username">{{userInfo.fname}}{{isTestUser? "(Test User)" : ""}}</h3>
          </div>
          <div class="userprofile-info-item">
            <span class="userprofile-username">{{userInfo.email}}</span>
          </div>
        </div>
      </div>
    </div>
    <div a11y_Button class="ya-icon-button service-button" (click)="navigationToUserAccount(0)">
      <div class="icon-container">
        <div class="inline-icon" inlineSVG="shop-icons.svg#ya-hypersoft-user-single"></div>
      </div>
      <div class="content-container">
        <h2 class="title" langkey="phUserProfile_Account"></h2>
        <div class="text content-container--subfont" langkey="phUserProfile_MyAccount_Description"></div>
      </div>
    </div>
    <div a11y_Button class="ya-icon-button service-button" (click)="navigationToUserAccount(1)">
      <div class="icon-container">
        <div class="inline-icon" inlineSVG="shop-icons.svg#ya-hypersoft-bestellungen"></div>
      </div>
      <div class="content-container">
        <h2 class="title" langkey="phUserProfile_Order"></h2>
        <div class="text content-container--subfont" langkey="phUserProfile_Order_Description"></div>
      </div>
    </div>
    <div a11y_Button class="ya-icon-button service-button" (click)="navigationToUserAccount(2)">
      <div class="icon-container">
        <div class="inline-icon" inlineSVG="shop-icons.svg#ya-hypersoft-adressen"></div>
      </div>
      <div class="content-container">
        <h2 class="title" langkey="phUserProfile_User_Addresses"></h2>
        <div class="text content-container--subfont" langkey="phUserProfile_MyAddress_Description"></div>
      </div>
    </div>
    <ng-container *ngIf="isItemTagEnabled">
      <div a11y_Button class="ya-icon-button service-button" (click)="navigationToUserAccount(3)">
        <div class="icon-container">
          <div class="inline-icon" inlineSVG="shop-icons.svg#ya-hypersoft-preferences-filter"></div>
        </div>
        <div class="content-container">
          <h2 class="title" langkey="phUserProfileDetail_Tags_Title"></h2>
          <div class="text content-container--subfont" langkey="phUserProfile_Tags_Subtext"></div>
        </div>
      </div>
    </ng-container>
    <!-- nur bei internem Login -->
    <div *ngIf="isAuthInternal" a11y_Button class="ya-icon-button service-button" (click)="navigateToChangePassword()">
      <div class="icon-container">
        <div class="inline-icon" inlineSVG="shop-icons.svg#ya-hypersoft-passwort"></div>
      </div>
      <div class="content-container">
        <h2 class="title" langkey="phUserProfileDetail_Label_ChangePassword"></h2>
        <div class="text content-container--subfont" langkey="phUserProfile_PasswordChange_Description"></div>
      </div>
    </div>

    <ng-container *ngIf="userProfileBonusSystemNav">
      <div a11y_Button class="ya-icon-button service-button" (click)="navigation('bonusaction')">
        <div class="icon-container">
          <div class="inline-icon" inlineSVG="shop-icons.svg#ya-hypersoft-bonus"></div>
        </div>
        <div class="content-container">
          <h2 class="title">{{userProfileBonusSystemNav?.label}}</h2>
          <div class="text content-container--subfont" langkey="phUserProfile_BonusPoint_Description"></div>
        </div>
      </div>
    </ng-container>
    <ng-container *ngIf="userProfileWebvoucherNav">
      <div a11y_Button class="ya-icon-button service-button" (click)="navigation('webvoucherdetail')">
        <div class="icon-container">
          <div class="inline-icon" inlineSVG="shop-icons.svg#ya-hypersoft-gutschein"></div>
        </div>
        <div class="content-container">
          <h2 class="title">{{userProfileWebvoucherNav?.label}}</h2>
          <div class="text content-container--subfont" langkey="phUserProfile_WebGutschein_Description"></div>
        </div>
      </div>
    </ng-container>
    <div a11y_Button class="ya-icon-button service-button" (click)="navigation('userlike')">
      <div class="icon-container">
        <div class="inline-icon" inlineSVG="shop-icons.svg#ya-hypersoft-herz-ganz-voll"></div>
      </div>
      <div class="content-container">
        <h2 class="title" langkey="phUserProfile_MyLike"></h2>
        <div class="text content-container--subfont" langkey="phUserProfile_MyLike_Description"></div>
      </div>
    </div>
    <div a11y_Button class="ya-icon-button service-button" (click)="navigation('feedback')">
      <div class="icon-container">
        <div class="inline-icon" inlineSVG="shop-icons.svg#ya-feedback"></div>
      </div>
      <div class="content-container">
        <h2 class="title" langkey="phUserProfile_Feedback"></h2>
        <div class="text content-container--subfont" langkey="phUserProfile_Feedback_Description"></div>
      </div>
    </div>
    <div class="botton-wrapper">
      <div class="ya-webshop-button-container">
        <button mat-flat-button (click)="logOut()"><span langkey="phUserProfileDetail_Label_Logout"></span></button>
      </div>
    </div>
  </div>
</div>